import {type BskyAgent} from '@atproto/api'

import {wsocFetch, xrpcPath} from '#/lib/wsoc/fetch'
import {type GetCapabilitiesResponse} from './types'

/**
 * Get server capabilities for the current user's account.
 *
 * @throws WsocFetchError on failure
 */
export async function getCapabilities(
  agent: BskyAgent,
  options?: {signal?: AbortSignal},
): Promise<GetCapabilitiesResponse> {
  const accessJwt = agent.session?.accessJwt
  if (!accessJwt) {
    throw new Error('getCapabilities requires an authenticated session')
  }
  return wsocFetch<GetCapabilitiesResponse>(
    xrpcPath('eu.wsocial.server.getCapabilities'),
    {accessJwt, signal: options?.signal, method: 'GET'},
  )
}
